import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { StyledCard, CardTitle, CollapsePanelHeader } from '../style'
import ApprovationsTable from './ApprovationsTable'

interface Props {
  productId?: number
  productCode?: string
}

const Aprovations: React.FC<Props> = ({ productId, productCode }) => {
  const [searchParams] = useSearchParams()
  const approvalIdParam = searchParams.get('approvalId')
  const [isOpen, setIsOpen] = useState(Boolean(approvalIdParam))

  useEffect(() => {
    if (approvalIdParam) {
      setIsOpen(true)
      const timeoutId = setTimeout(() => {
        const el = document.getElementById('product-approvals-section')
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 350)
      return () => clearTimeout(timeoutId)
    }
  }, [approvalIdParam])

  const hasProduct = typeof productId === 'number' && !Number.isNaN(productId) && productId > 0

  return (
    <StyledCard id="product-approvals-section">
      <CollapsePanelHeader
        $open={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <CardTitle>Aprovações</CardTitle>
        {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </CollapsePanelHeader>
      {isOpen && (
        hasProduct ? (
          <ApprovationsTable productId={productId as number} productCode={productCode} />
        ) : (
          <div
            style={{
              padding: '16px 4px',
              color: '#6b7280',
              fontSize: 13,
            }}
          >
            Salve o produto para começar a cadastrar aprovações.
          </div>
        )
      )}
    </StyledCard>
  )
}

export default Aprovations
